import React from "react";
import { cn } from "@gettactic/helpers";
import { Badge } from "@cmp-src/primitives/badge";

export interface WizardReviewBadgeListProps {
  label: string;
  items: string[];
  emptyText?: string;
  className?: string;
}

export const WizardReviewBadgeList: React.FC<WizardReviewBadgeListProps> = ({
  label,
  items,
  emptyText = "None selected",
  className
}) => (
  <div className={className}>
    <span className="text-sm text-neutral-500">{label}</span>
    <div className="mt-1">
      {items.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {items.map((item) => (
            <Badge key={item} variant="secondary">
              {item}
            </Badge>
          ))}
        </div>
      ) : (
        <span className="text-sm text-neutral-400">{emptyText}</span>
      )}
    </div>
  </div>
);
